<ng-container *ngIf="loginForm">
    <div [formGroup]="loginForm">
        <div class="card">
            <div class="card-body with-footer">
                <h2 [class.text-center]="isForwarding">
                    <mat-spinner *ngIf="isForwarding"
                                 class="mx-auto my-4"></mat-spinner>
                    {{isForwarding ? 'Already Logged In...Redirecting You' : header ? header : 'Sign in to your account below.'}}
                </h2>
                <div *ngIf="maintenanceWindow.active" class="alert alert-danger maintenance-banner">
                    PayHOA is currently unavailable while our servers are being upgraded.<br>Service should be restored by {{maintenanceWindow.time}}.
                </div>

                <ng-container *ngIf="!isForwarding">
                    <div class="form-group">
                        <label class="text-left font-weight-bold form-control-required" for="user-email">{{'Email'}}</label>
                        <input #loginInput
                               id="user-email"
                               aria-describedby="email-address"
                               class="form-control"
                               formControlName="email"
                               autocomplete="username"
                               placeholder="{{'name@example.com'}}"
                               required
                               type="email"
                               [readonly]="isSubmitting"
                               (keyup.enter)="login()"/>
                        <app-field-error-display [control]="isFieldValid('email')"></app-field-error-display>
                    </div>

                    <div class="form-group">
                        <label class="text-left font-weight-bold form-control-required" for="user-password">{{'Password'}}</label>
                        <input #loginPasswordInput
                               id="user-password"
                               aria-describedby="password"
                               class="form-control"
                               formControlName="password"
                               autocomplete="current-password"
                               minlength="6"
                               placeholder="&bull;&bull;&bull;&bull;&bull;&bull;&bull;"
                               required
                               type="password"
                               [readonly]="isSubmitting"
                               (keyup.enter)="login()"/>
                        <app-field-error-display [control]="isFieldValid('password')"></app-field-error-display>
                    </div>
                </ng-container>
            </div>

            <div class="card-footer d-flex flex-column justify-content-center">
                <app-spinner-button *ngIf="isSubmitting"
                                    [buttonClasses]="['mx-auto']">{{'Logging in'}}</app-spinner-button>
                <ng-container *ngIf="!isSubmitting && !isForwarding">
                    <app-button type="primary"
                                [buttonClasses]="['mr-0']"
                                (onClick)="login(true)">{{'Log in'}}</app-button>
                    <div class="text-right mt-3">
                        <div class="description-text w-100">
                            <div class="d-inline-block text-nowrap">
                                <app-button type="link"
                                            [buttonClasses]="['mr-0']"
                                            (onClick)="forgotPassword()">{{'Forgot your password?'}}</app-button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div *ngIf="!isForwarding && showSignupLink"
         class="font-size-normal text-center pt-4">
        {{'Don\'t have an account? '}}
        <app-button type="link"
                    [buttonClasses]="['mr-0']"
                    [routeTo]="['/sign-up']">{{'Sign up'}}</app-button>
    </div>
</ng-container>
